import React from "react";
import "../styles/home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Home = () => {
  return (
    <>
      <div className="home_container">
        <div className="home">
          <h3 className="sort_header_text">This project is developed by</h3>
          <h3 className="sort_header_text">Soumyajit Pan</h3>
          <h3 className="sort_header_text">System Engineer @ Infosys</h3>
          <FontAwesomeIcon
            icon={faLinkedin}
            className="linkedin"
            onClick={() => {
              window.open(
                "https://www.linkedin.com/in/soumyajit-pan-29-som/",
                "_blank"
              );
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Home;
